import React from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import Footer from '../components/Footer';

function Home() {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh', // Ensure full viewport height
                justifyContent: 'space-between', // Ensures the footer is at the bottom
            }}
        >
            {/* Main Content */}
            <Box
                sx={{
                    flex: 1,
                    textAlign: 'center',
                    padding: 4,
                    backgroundColor: '#f5f5f5',
                }}
            >
                <Typography variant="h2" gutterBottom>
                    Welcome to SciCruit
                </Typography>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                    Revolutionizing sales recruitment with AI-driven insights.
                </Typography>

                {/* Brief Descriptions */}
                <Grid container spacing={4} justifyContent="center" sx={{ marginTop: 4 }}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" gutterBottom>
                            For Employers
                        </Typography>
                        <Typography color="textSecondary">
                            Streamline your sales hiring process with AI-powered candidate matching and actionable analytics.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6" gutterBottom>
                            For Job Seekers
                        </Typography>
                        <Typography color="textSecondary">
                            Discover your dream sales job and showcase your skills with confidence through our streamlined platform.
                        </Typography>
                    </Grid>
                </Grid>

                {/* Get Started Buttons */}
                <Box sx={{ marginTop: 4 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        sx={{ marginRight: 2 }}
                        onClick={() => (window.location.href = 'http://scicruit.ai/employer-signup')} // Redirects to employer signup
                    >
                        Get Started - Employers
                    </Button>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="large"
                        onClick={() => (window.location.href = 'https://scicruit.ai/jobseeker-signup')}
                    >
                        Get Started - Job Seekers
                    </Button>
                </Box>
            </Box>

            {/* Footer */}
            <Footer />
        </Box>
    );
}

export default Home;

